var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C9.70435 0 8.94129 0.316071 8.37868 0.87868C7.81607 1.44129 7.5 2.20435 7.5 3H2.25C1.65326 3 1.08097 3.23705 0.65901 3.65901C0.237053 4.08097 0 4.65326 0 5.25L0 18.75C0 19.3467 0.237053 19.919 0.65901 20.341C1.08097 20.7629 1.65326 21 2.25 21H3C3 21.1989 3.07902 21.3897 3.21967 21.5303C3.36032 21.671 3.55109 21.75 3.75 21.75C3.94891 21.75 4.13968 21.671 4.28033 21.5303C4.42098 21.3897 4.5 21.1989 4.5 21H19.5C19.5 21.1989 19.579 21.3897 19.7197 21.5303C19.8603 21.671 20.0511 21.75 20.25 21.75C20.4489 21.75 20.6397 21.671 20.7803 21.5303C20.921 21.3897 21 21.1989 21 21H21.75C22.3467 21 22.919 20.7629 23.341 20.341C23.7629 19.919 24 19.3467 24 18.75V5.25C24 4.65326 23.7629 4.08097 23.341 3.65901C22.919 3.23705 22.3467 3 21.75 3H16.5C16.5 2.20435 16.1839 1.44129 15.6213 0.87868C15.0587 0.316071 14.2956 0 13.5 0L10.5 0ZM9 3C9 2.60218 9.15804 2.22064 9.43934 1.93934C9.72064 1.65804 10.1022 1.5 10.5 1.5H13.5C13.8978 1.5 14.2794 1.65804 14.5607 1.93934C14.842 2.22064 15 2.60218 15 3H9ZM4.5 19.5V4.5H6V19.5H4.5ZM18 19.5V4.5H19.5V19.5H18Z",
    fill: "#1B3E61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingLeave);
export default __webpack_public_path__ + "static/media/upcomingLeave.f7a9363a6318ddc6ca4d4ffe67181608.svg";
export { ForwardRef as ReactComponent };